export default "__VITE_ASSET__ktwyuQSK__"